import { render, staticRenderFns } from "./VUserSearchField.vue?vue&type=template&id=25937460&"
import script from "./VUserSearchField.vue?vue&type=script&lang=js&"
export * from "./VUserSearchField.vue?vue&type=script&lang=js&"
import style0 from "./VUserSearchField.vue?vue&type=style&index=0&id=25937460&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports